<script>
  import { onMount } from "svelte";
  import Search from "./Search.svelte";
  import Select from "svelte-select";
  import Icon from "./Icons.svelte";

  export let dataset;
  export let selectedSector;
  export let selectedSubsector;
  export let selectedState;
  export let selectedResourceType;
  export let searchText = "";
  export let row;
  export let totalEntries;

  // Pagination state
  export let currentPage = 1;
  const itemsPerPage = 25;
  $: totalPages = Math.ceil(totalEntries / itemsPerPage);

  // resets page to 1 when user changes a dropdown filter
  $: if (
    selectedState ||
    selectedSector ||
    selectedSubsector ||
    selectedResourceType
  ) {
    currentPage = 1;
  }

  // Calculate the range of entries being shown
  $: startEntry = (currentPage - 1) * itemsPerPage + 1;
  $: endEntry = Math.min(startEntry + itemsPerPage - 1, totalEntries);

  if (endEntry > totalEntries) {
    endEntry = totalEntries;
  }

  const optionIdentifier = "value";
  const labelIdentifier = "label";
  let filterCategory = dataset.filterCategory;
  let filterValue = dataset.filterValue;

  // Handles the subsector filter if one exists
  function normalizeSubsector(urlSubsector) {
    // Special cases mapping - this is the only subsector
    // that has a different name in the URL than in the dataset
    // (it's missing the word "and" in the URL)
    const specialCases = {
      "power-renewable-energy": "Power & Renewable Energy",
    };

    // Check if the URL subsector is a special case
    if (specialCases[urlSubsector]) {
      return specialCases[urlSubsector];
    }

    // Normal normalization process
    return urlSubsector
      .split("-")
      .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
      .join(" ")
      .replace("And", "&");
  }

  function removeRowActiveTitleStyle() {
    const title = document.querySelectorAll(".title--active");
    title.forEach((item) => {
      item.classList.remove("title--active");
    });
  }

  function removeExtraContentStyle() {
    const extraContent = document.querySelectorAll(".extra-content");
    extraContent.forEach((content) => {
      if (content.classList.contains("active")) {
        content.classList.remove("active");
        content.classList.add("hide");
      }
    });
  }

  function switchRowBottomLine() {
    const rowTitle = document.querySelectorAll(".title");
    const extraContent = document.querySelectorAll(".extra-content");
    extraContent.forEach((item) => {
      if (item.classList.contains("table__body__cell--border")) {
        item.classList.remove("table__body__cell--border");
      }
    });
    rowTitle.forEach((item) => {
      if (!item.classList.contains("table__body__cell--border")) {
        item.classList.add("table__body__cell--border");
      }
    });
  }

  function handleSelect(event, selectName) {
    if (row.isOpen) {
      toggleRowState();
    }

    switch (selectName) {
      case "Sector":
        selectedSector = event.detail.value;
        break;
      case "Subsector":
        selectedSubsector = event.detail.value;
        break;
      case "State":
        selectedState = event.detail.value;
        break;
      case "Resource Type":
        selectedResourceType = event.detail.value;
        break;
      default:
        console.error("Invalid selectName:", selectName);
    }
  }

  function toggleRowState() {
    row.isOpen = !row.isOpen;
    removeRowActiveTitleStyle();
    removeExtraContentStyle();
    switchRowBottomLine();
  }

  function handleClear(selectName) {
    if (row.isOpen) {
      row.isOpen = !row.isOpen;
      removeRowActiveTitleStyle();
      removeExtraContentStyle();
      switchRowBottomLine();
    }

    switch (selectName) {
      case "Sector":
        selectedSector = "";
        break;
      case "Subsector":
        selectedSubsector = "";
        break;
      case "State":
        selectedState = "";
        break;
      case "Resource Type":
        selectedResourceType = "";
        break;
      default:
        console.error("Invalid selectName:", selectName);
    }
  }

  /* ------------------------------------------------------ */
  /*                  Handle Chevron Icons                  */
  /* ------------------------------------------------------ */
  // handle the icon
  const chevronUp =
    '<svg class="iconUp" width="16" height="10" viewBox="0 0 32 32" xmlns="http://www.w3.org/2000/svg"><path d="M28 15 14 0 0 15h28z" fill="#000"/></svg>';
  const chevronDown =
    '<svg class="iconDown" width="16" height="10" viewBox="0 0 32 32" xmlns="http://www.w3.org/2000/svg"><path d="m0 0 14 15L28 0H0z" fill="#000"/></svg>';
  let chevron = chevronDown;
  let isListOpen = false;
  let listCategoryOpen = false;

  $: chevron = isListOpen ? chevronUp : chevronDown;

  /* ------------------------------------------------------ */
  /*                    Handle Pagination                   */
  /* ------------------------------------------------------ */
  // Handle clicking the pagination buttons
  function updateCurrentPage(newPage) {
    currentPage = newPage;
  }

  function resetExtraContent() {
    document.querySelectorAll(".extra-content.active").forEach((content) => {
      content.classList.remove("active");
      content.classList.remove("table__body__cell--border");
      content.classList.add("hide");
    });

    document.querySelectorAll(".title--active").forEach((title) => {
      title.classList.remove("title--active");
      title.classList.add("table__body__cell--border");
    });
  }

  function goToNextPage() {
    if (currentPage < totalPages) {
      resetExtraContent();
      updateCurrentPage(currentPage + 1);
    }
  }

  function goToPreviousPage() {
    if (currentPage > 1) {
      resetExtraContent();
      updateCurrentPage(currentPage - 1);
    }
  }

  /* ------------------------------------------------------ */
  /*                         onMount                        */
  /* ------------------------------------------------------ */
  onMount(() => {
    if (!selectedSubsector && dataset.subsector_filter) {
      selectedSubsector = normalizeSubsector(dataset.subsector_filter);
    }
    isListOpen = false;

    if (!selectedResourceType) {
      // console.log("selectedResourceType:", dataset);
      if (dataset.filterCategory === "newsletter") {
        selectedResourceType = "Newsletter";
      } else if (dataset.filterCategory === "articles") {
        selectedResourceType = "Article"
      }
    }
  });
</script>

<!-- dropdown filters -->
  <div class="selects {(filterCategory === 'states' || filterCategory === 'articles' || filterCategory === 'newsletter' || filterCategory === 'sectors') ? 'selects--two' : ''}" data-test="{filterCategory === 'articles' ? 'im article' : 'i dont know who i am' }">
    {#if filterCategory == "states" || (filterCategory == "sectors" && !filterValue)}
      <!-- Sector dropdown only if it's not a specific state page -->
      <div class="select-container {filterCategory !== 'newsletter' || filterCategory === 'sectors' ? 'select-container--two' : ''}">
        <div class="label">Sector</div>
        <Select
          indicatorSvg={chevron}
          showChevron={true}
          {optionIdentifier}
          {labelIdentifier}
          items={dataset.sectors}
          placeholder="Select a sector"
          on:select={(event) => handleSelect(event, "Sector")}
          on:clear={(event) => handleClear("Sector")}
        />
      </div>
    {/if}
  
    {#if (filterCategory === "sectors" && filterValue) || filterCategory === "newsletter"}
      <!-- Subsector dropdown for sectors or newsletter category -->
      <div class="select-container {(filterCategory === 'sectors' || filterCategory === 'newsletter') ? 'select-container--two' : ''}">

        <div class="label">Subsector</div>
        <Select
          bind:value={selectedSubsector}
          indicatorSvg={chevron}
          showChevron={true}
          {optionIdentifier}
          {labelIdentifier}
          items={dataset.subsectors}
          placeholder="Select a subsector"
          on:select={(event) => handleSelect(event, "Subsector")}
          on:clear={(event) => handleClear("Subsector")}
        />
      </div>
    {/if}
  
    {#if filterCategory !== "states"}
      <!-- State dropdown for any category except when it's a general states page without a specific state -->
      <div data-testing="{filterCategory}" class="select-container {(filterCategory === 'sectors' || filterCategory === 'newsletter' || filterCategory === 'articles') ? 'select-container--two' : ''}">
        <div class="label">State</div>
        <Select
          indicatorSvg={chevron}
          showChevron={true}
          {optionIdentifier}
          {labelIdentifier}
          items={dataset.states}
          placeholder="Select a state"
          on:select={(event) => handleSelect(event, "State")}
          on:clear={() => handleClear("State")}
        />
      </div>
    {/if}
  </div>

<div class="stiky-header">
  <!--"Showing ### Entries" + left/right buttons-->
  <div class="options options__container options__container--sticky">
    <section class="options__navigation">
      <Search bind:searchText />
      <div class="options__navigation-inner">
        <span class="options__table-total-entries"
          >Showing {startEntry}-{endEntry} of {totalEntries} entries</span
        >
        <button
          id="btn-scroll-left"
          class="btn btn--scroll btn--scroll--left"
          class:inactive={currentPage === 1}
          aria-label="Go to previous page"
          on:click={goToPreviousPage}
          disabled={currentPage === 1}
          ><Icon
            id="icon-scroll-left"
            name="Icon-left"
            class="icon {currentPage === 1 ? 'inactive' : ''}"
          /></button
        >
        <button
          id="btn-scroll-right"
          class="btn btn--scroll btn--scroll--right"
          class:inactive={currentPage === totalPages}
          aria-label="Go to next page"
          on:click={goToNextPage}
          disabled={currentPage === totalPages}
          ><Icon
            id="icon-scroll-right"
            name="Icon-right"
            class="icon {currentPage === totalPages ? 'inactive' : ''}"
          /></button
        >
      </div>
    </section>
  </div>
</div>
<style lang="scss">
  @use "../scss/abstracts/" as *;
  @use "../scss/components/table-container";
  @use "../scss/components/button";
  @use "../scss/components/label";
  @use "../scss/components/select";
  @use "../scss/components/options";
  :global(.selectContainer) {
    &:hover {
      --borderRadius: 0;
      --background: #{$color-gray-25};
    }
  }

  :global(.selectContainer .item.active) {
    position: relative;
    --itemIsActiveBG: transparent;
    --itemIsActiveColor: $color-text-gray-500;
    --itemHoverBG: $color-blue-25;

    &:hover {
      background-color: $color-blue-25;
    }

    &::before {
      content: "L";
      font-family: arial;
      -ms-transform: scaleX(-1) rotate(-35deg); /* IE 9 */
      -webkit-transform: scaleX(-1) rotate(-35deg); /* Chrome, Safari, Opera */
      transform: scaleX(-1) rotate(-35deg);
      display: inline-block;
      line-height: 1rem;
      color: $color-blue-800;
      text-align: center;
      font-size: 14px;
      position: absolute;
      left: 16px;
      top: 10px;
    }
  }

  :global(.selectContainer) {
    --internalPadding: 0 4px 0 0 !important;
    --itemFirstBorderRadius: 2px;
    --placeholderColor: $color-text-gray-600;
  }

  :global(.selectContainer .item) {
    --itemPadding: #{rem(8)} #{rem(40)} #{rem(12)};
    text-overflow: unset !important;
    overflow: unset !important;
    white-space: unset !important;
    font-weight: bold;
    &:hover {
      background-color: $color-blue-25 !important;
    }
  }
  :global(.listContainer) {
    --listBorderRadius: rem(2);
    --listZIndex: 15;
    --listMaxHeight: #{rem(450)};
    --height: 1.2;
    min-width: 250px !important;
  }

  :global(.iconDown) {
    pointer-events: none;
    filter: invert(25%) sepia(18%) saturate(172%) hue-rotate(343deg)
      brightness(96%) contrast(87%);

    &:hover,
    &:focus {
      filter: invert(25%) sepia(18%) saturate(172%) hue-rotate(343deg)
        brightness(96%) contrast(87%);
    }
  }

  :global(.iconUp) {
    pointer-events: none;
    filter: invert(29%) sepia(13%) saturate(765%) hue-rotate(181deg)
      brightness(95%) contrast(89%);

    &:hover,
    &:focus {
      // color brand blue 600
      filter: invert(39%) sepia(72%) saturate(6596%) hue-rotate(200deg)
        brightness(100%) contrast(84%);
    }
  }

  :global(.clearSelect) {
    width: rem(16);
    height: rem(16);
  }

  :global(.selectContainer > input) {
    --inputPadding: 0 28px 0 0;
  }

  :global(.indicator) {
    --indicatorRight: 4px;
    top: auto !important;
  }

  :global(.selectedItem) {
    color: $color-blue-800;
  }
  .select-container :global(.selectContainer:hover .indicator) {
    // $color-blue-800
    filter: brightness(0) saturate(100%) invert(18%) sepia(16%) saturate(6897%)
      hue-rotate(177deg) brightness(94%) contrast(101%);
  }

  .select-container :global(.selectContainer:focus .indicator) {
    // $color-blue-800
    filter: brightness(0) saturate(100%) invert(18%) sepia(16%) saturate(6897%)
      hue-rotate(177deg) brightness(94%) contrast(101%);
  }

  .select-container :global(.selectContainer:active .indicator) {
    // $color-gray-700;
    filter: invert(22%) sepia(64%) saturate(0%) hue-rotate(221deg)
      brightness(116%) contrast(95%);
  }
</style>
